import {
    Accordion as Acdn,
    AccordionDetails,
    AccordionSummary,
    Grid,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { AccordionProps } from './props';

export const Accordion = ({
    icon,
    title,
    titleChildren,
    children,
    defaultExpanded = true,
    expanded,
    onChange,
    mt = '20px',
    padding = '8px 16px 16px',
}: AccordionProps) => {
    const isControlled = expanded !== undefined;

    return (
        <Acdn
            style={{ marginTop: mt }}
            expanded={isControlled ? expanded : undefined}
            defaultExpanded={!isControlled ? defaultExpanded : undefined}
            onChange={onChange}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
            >
                <Grid
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    gap="14px"
                >
                    {icon || <FilterAltIcon color="primary" />} {title}
                    <Grid position="absolute" right={50}>
                        {titleChildren}
                    </Grid>
                </Grid>
            </AccordionSummary>
            <AccordionDetails style={{ padding }}>{children}</AccordionDetails>
        </Acdn>
    );
};
